// extracted by mini-css-extract-plugin
export default {"onImage":"W1Ia6t","second":"ZRyGnR","third":"ETp8VY","eventInfo":"sC3ITF","text":"OxJCrW","container":"teo7pT","badge":"pet5MA","fullWidth":"GLmg8J"};